<template>
  <div class="text-container">
    <!-- Render the full HTML content -->
    <div v-html="fileText"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fileText: `
        <h3>НУУЦЛАЛЫН БОДЛОГО</h3>
        <p>Энэхүү Нууцлалын бодлого нь Монгол Улсын Хүний хувийн мэдээлэл хамгаалах тухай хууль болон Кибер аюулгүй байдлын хуульд үндэслэн Хэрэглэгчийн хувийн мэдээллийг цуглуулах, боловсруулах, ашиглах, аюулгүй байдлыг хангахтай холбоотой харилцааг зохицуулна.</p>
        <p>“Финтакс Платформ” ХХК (“Мэдээлэл хариуцагч”) нь Хэрэглэгч (“Та” эсхүл “Хэрэглэгч”)-ийн Surgalt.Fintax.mn -н Вебсайт (“Платформ”) -д бүртгүүлж, ашиглах үед хүний хувийн мэдээлэл хамгаалах тухай хуульд заасан нөхцөл, журмын дагуу таны хувийн мэдээллийг цуглуулж, боловсруулж, ашиглах бөгөөд мэдээллийн аюулгүй байдлыг хангана.</p>
        <p>Та “Surgalt.Fintax.mn”-д бүртгүүлэхээс өмнө энэхүү “Нууцлалын бодлого”-той бүрэн танилцах үүрэгтэй.</p>
        <p>Хэрэглэгч нь “Нууцлалын бодлого”-д заасан нөхцөлүүдийг бүрэн хүлээн зөвшөөрч, харгалзуулсан хэсгийг дарж, идэвхжүүлснээр “Surgalt.Fintax”-г ашиглах явцад өөрийн хувийн мэдээллийг цуглуулж, боловсруулж, ашиглах цахим зөвшөөрлийг мэдээлэл хариуцагчид олгосонд тооцно.</p>
        <p>Хэрэглэгч нь Үйлчилгээний нөхцөл болон Нууцлалын бодлогыг хүлээн зөвшөөрөхгүй татгалзах эрхтэй.</p>
        
        <h4>НЭГ. Хэрэглэгчийн хувийн мэдээлэл цуглуулах, боловсруулах, ашиглах үндэслэл, зорилго</h4>
        <p>Мэдээлэл хариуцагч нь Хэрэглэгчээс олгосон цахим зөвшөөрлийг үндэслэн мэдээллийг цуглуулж, боловсруулж, ашиглана.</p>
        <p>Мэдээлэл хариуцагч нь Хэрэглэгчийн мэдээллийг цуглуулж, боловсруулах, ашиглах ажиллагаанд таны хувийн мэдээллийн үнэн зөв, бүрэн бүтэн байдлыг алдагдуулахгүй байх, мэдээллийн аюулгүй байдлыг хангах зарчмуудыг баримтална.</p>
        
        <h4>ХОЁР. Мэдээл хариуцагчийн холбоо барих мэдээлэл</h4>
        <p>Мэдээлэл хариуцагч нь Монгол Улсын Компанийн тухай хуулийн дагуу үүсгэн байгуулагдсан ФИНТАКС ПЛАТФОРМ ХХК байна.</p>
        <p>Хэрэглэгч нь энэхүү Нууцлалын бодлогын нөхцөл, хэрэгжилттэй холбоотой асуудлаар info@taxacc.mn имэйл хаягаар холбогдож, санал, хүсэлт, гомдлоо шийдвэрлүүлнэ.</p>
        
        <h4>ГУРАВ. Хэрэглэгчийн мэдээллийг боловсруулах, ашиглах нөхцөл, хугацаа</h4>
        <p>Мэдээлэл хариуцагч нь Хэрэглэгчийн мэдээллийг дараах тохиолдолд боловсруулж ашиглана. Үүнд:</p>
        <ul>
          <li>Таны гар утасны дугаараар холбогдох, эсхүл цахим шууданд мэдээлэл, мэдэгдэл илгээх тохиолдолд;</li>
          <li>Хэрэглэгчийг танин, баталгаажуулах үед;</li>
          <li>Хэрэглэгчээс ирүүлсэн гомдлыг хянан шалгах явцад;</li>
          <li>“Surgalt.Fintax”-ийн ашиг тусын тулд хяналт, сайжруулалт, хөгжүүлэлт, тест хийх;</li>
          <li>Техникийн засвар хийх мэдэгдэл;</li>
          <li>Идвэхжүүлэлт болон маркетингийн зориулалтаар.</li>
        </ul>
        <p>Мэдээлэл хариуцагч нь Хэрэглэгчийн хувийн халдашгүй байдлыг хүндэтгэн дээдлэх бөгөөд бүртгэлийн мэдээллийг Монгол Улсын Засгийн газраас баталсан кибер аюулгүй байдлын тухай журамд заасан хугацаагаар хадгална.</p>
        <p>Хэрэглэгч системд нэвтрэх цахим хаягын, нууц үг болон баталгаажуулалтын код зэргээ бусдад задруулахгүй байх үүрэгтэй.</p>
        <p>Цахим хаягын нэвтрэх эрхээ бусдад алдсанаас үүдэлтэй Хэрэглэгчийн хуудаст үүссэн аливаа хор, хохирлыг Мэдээлэл хариуцагч хариуцахгүй болно.</p>
        <p>Мэдээлэл хариуцагч нь Хэрэглэгчийн хандах эрхийг ашиглан мэдээлэлд нэвтрэх боломжгүй болохыг анхааруулж байна.</p>
        
        <h4>ДӨРӨВ. Хэрэглэгчийн хувийн мэдээллийг нийтэд ил болгох нөхцөл</h4>
        <p>Мэдээлэл харилцагч нь бусад байгууллага, хувь хүний шаардлагаар Хэрэглэгчийн хувийн мэдээллийг нийтэд ил болгохгүй.</p>
        
        <h4>ТАВ. Хэрэглэгчийн мэдээллийг дамжуулах журам</h4>
        <p>Мэдээлэл хариуцагч нь Таны хувийн мэдээллийг гуравдагч этгээдэд ашиг олох зорилгоор дамжуулахгүй, түгээхгүй, худалдахгүй бөгөөд үйлчилгээний хэрэгцээнээс гадуур ашиг олох зорилгоор ашиглахгүй болно.</p>
        <p>Мэдээлэл хариуцагчаас томилсон эрх бүхий албан тушаалтан Таны хувийн мэдээлэлд хандах эрхтэй ба эрх бүхий албан тушаалтан Таны хувийн мэдээллийг гуравдагч этгээдэд задруулах эсхүл өөрийн хувийн сонирхолд нийцүүлэн нээлттэй бус мэдээллийг задруулахыг хатуу хориглоно. Хориглосон зохицуулалтыг зөрчсөн эрх бүхий албан тушаалтан хууль зүйн хариуцлага хүлээнэ.</p>
        
        <h4>ЗУРГАА. Бусад</h4>
        <p>Хэрэглэгч нь “Surgalt.Fintax” дах и-мэйл, утасны дугаар, болон дансны мэдээлэл зэрэг бүртргэлийн цахим хаягаас бусад өөрийн хувийн мэдээллийг өөрчлөх эрхтэй.</p>
        <p>Кибер халдлага, эрх бүхий албан тушаалтны алдаатай үйл ажиллагаа, эсхүл программ хангамж болон мэдээллийн санд гэмтэл гарсны улмаас Таны хувийн мэдээлэл алдагдсан тохиолдолд Мэдээлэл хариуцагчаас таны бүртгүүлсэн и-мэйл хаяг, гар утасны дугаарт нэн даруй мэдэгдэл хүргүүлнэ. Та мэдэгдэлд заасан арга хэмжээг заавар, анхааруулгын дагуу авах үүрэгтэй.</p>
        <p>“ФИНТАКС ПЛАТФОРМ” ХХК нь Нууцлалын бодлогод өөрчлөлт оруулах эрхтэй ба Нууцлалын бодлогод өөрчлөлт оруулсан тухай бүрд өөрсдийн WEB хуудсанд бүртгэлтэй хэрэглэгчдэд нээлттэй нийтлэх бөгөөд Хэрэглэгч нь уншиж танилцах үүрэг хүлээнэ.</p>
      `
    };
  }
};
</script>

<style scoped>
.text-container {
  margin: 20px auto;
  max-width: 800px;
  padding: 20px;
  font-family: sans-serif;
}

h1 {
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 20px;
}

h4 {
  font-size: 20px;
  font-weight: bold;
  margin-top: 20px;
  margin-bottom: 10px;
}

p {
  line-height: 1.6;
  margin-bottom: 1em;
}

ul {
  margin-left: 20px;
  margin-bottom: 1em;
}

li {
  margin-bottom: 0.5em;
}
</style>
